import Header from "../components/Header/Header"
import Dropdown from "../components/Form/Dropdown"
import { Link, Outlet, useLocation, useNavigate } from "react-router-dom"
import { createContext, useEffect, useRef, useState } from "react"
import { initCookieConsent, setCookiesLanguage, showCookieConsent } from "../components/UI/Cookies"
import logo from "../assets/svg/logo.svg"
import Navigation, { HeaderLink } from "../components/Header/Navigation"
import Overlay from "../components/Header/Overlay"
import { useLenis } from "@studio-freight/react-lenis"
import axios from "axios"
import { APIURL, toURL } from ".."
import Hamburger from "../components/Header/Hamburger"
import gen from "../assets/a_gen_tura.png";
import fis from "../assets/FIS_logo.png";
import kme from "../assets/logo_bile.png";

export const AppContext = createContext();

const Layout = ({children,language}) => {
    const headerRef = useRef();

    const karty = [{id:1,type:'definuj'},{id:2,type:'rozhoduj'},{id:3,type:'vymyslej'}]
    const [cards, setCards] = useState(karty);

    const [pages, setPages] = useState({});
    
    useEffect(() => {
      setCookiesLanguage('cs');
    }, [language]);

    const showConsent = () => {
      showCookieConsent();
  }

    useEffect(() => {
      if (process.env.NODE_ENV === 'production') {
        initCookieConsent();
      }
    }, []);

    useEffect(()=>{
      if (headerRef.current) {
        setTimeout(() => {
          document.body.style.paddingTop = headerRef.current.el?.scrollHeight+'px';  
        }, 500);
      }
    },[headerRef])


    return (
        <AppContext.Provider value={{language, cards,pages, setPages}}>
          <Header fixed ref={headerRef} stopScroll > 
            <div className="w-4/5 maxSection m-auto flex justify-between items-center bg-white bg-opacity-80 backdrop-blur-sm !px-4 rounded-xl border-2 border-[#D1EDEE]">
              <HeaderLink to="/"><img src={logo} alt="Lorem ipsum logo" className="max-h-8" /></HeaderLink>
              <Navigation hideOnMobile={1000}>
                <HeaderLink className="sfx" to="/#jak-to-funguje">Jak to funguje?</HeaderLink>
                {/* <HeaderLink className="px-4">Kontakt</HeaderLink> */}
                <LinkButton type='karty' light />
                <LinkButton type='workshop' />
              </Navigation>
              <Hamburger lineclassName='!bg-purplee-100' show={1000} />
            </div>
            <Overlay className="bg-azur-200 shadow-lg gap-4" hamburgerClassName="!absolute !right-4 !top-4" data-lenis-prevent >
                <HeaderLink className="sfx" to="/#jak-to-funguje">Jak to funguje?</HeaderLink>
                {/* <HeaderLink className="px-4">Kontakt</HeaderLink> */}
                <LinkButton type='karty' light />
                <LinkButton type='workshop' />
            </Overlay>
          </Header>
          {children}
          <footer className='mt-auto bg-purplee-500 text-white'> 
            <div className="w-full h-20 bg-azur-200 rounded-b-3xl"></div>
            <div className="py-12 px-[5%] maxSection flex flex-col gap-8 items-start"> 
                <img src={logo} alt="Logo Lorem ipsum" className="invert max-w-[50vw]" />
                <div className="flex flex-row w-full justify-between flex-wrap">
                  <div className="footer__left">
                      <h2>Mějte nápady dřív, než ostatní začnou.</h2>
                  </div>
                  <div className='footer__right flex-nowrap !gap-y-0'>
                      <div className="w-full">
                        <Link to="/workshop" className="sfx">Workshop</Link>
                        <Link to="/karty" className="sfx">Karty</Link> 
                      </div>
                      <div className="w-full"> 
                        <a href="/Lorem-ipsum-GDPR.pdf" target="_blank" className="sfx">GDPR</a> 
                        <a onClick={showConsent} className="sfx">Nastavení soukromí</a>  
                      </div>
                      <div className="w-full text-sm text-left tablet:pt-7"> 
                        <div>
                          <b>Adresa:</b><br/>Náměstí Winstona<br/>Churchilla 1938/4,<br/>Praha 3 - Žižkov<br/>130 67
                        </div> 
                        <div className="pt-4">
                          <b>E-mail:</b><br/>
                          <a href="mailto:lorem.ipsum@agenturagen.cz" className="!underline">lorem.ipsum@agenturagen.cz</a>
                        </div> 
                      </div>
                  </div>
                </div>
            </div>
            <div className="bg-[url('../assets/svg/footer-pattern.svg')] bg-contain bg-repeat-x	w-full h-[60px] lg:h-[100px] mb-10"></div>
        </footer>
        <div className="w-full bg-purplee-300 text-white py-3 px-vw">
          <div className="maxSection flex mobil:flex-col items-center gap-3">
            <p className="max-w-lg text-xs mobil:text-center font-extralight mr-auto">Karty Lorem ipsum vznikly ve spolupráci pedagogů a studentů na Katedře multimédií FIS VŠE. Výtěžek z aktivit na této stránce jde na podporu výuky multimédií na FIS VŠE.</p>
            <a href="https://agenturagen.cz/" target="_blank"><img src={gen} alt="Agentura Gen" /></a>
            <a href="https://kme.vse.cz/" target="_blank"><img src={kme} alt="KME" /></a>
            <a href="https://fis.vse.cz/" target="_blank"><img src={fis} alt="FIS" /></a>
          </div>
        </div>
        </AppContext.Provider>
    )
}

export const LinkButton = ({type,to, light, className='', children,...rest}) => <HeaderLink to={to?to:type==='karty'?'/karty':'/workshop'} className={'button '+(light?"light ":"workshop ")+className} {...rest}>{type&&(type==='karty'?'Chci karty':'Chci workshop')}{children}</HeaderLink>

export default Layout;